import { z } from 'my-zod'

export const customerOrderSearchRequest = z.object({
  search: z.string().min(3, 'Should be at least 3 characters'),
  outfitterId: z.number().nullish()
})

export type customerOrderSearchRequest = z.infer<typeof customerOrderSearchRequest>
